


$('.js-tests-accordion-header').click(function(){
  let accordionContainer = $(this).closest('.js-tests-accordions-c')
  let curEl = $(this).parent()

  curEl.toggleClass('opened')
  curEl.find('.js-tests-accordion-content').slideToggle()

  // close other accordions
  if (accordionContainer.length){
    accordionContainer.find('.js-tests-accordion').each(function (i, el){
      if (el !== curEl[0]){
        $(el).removeClass('opened')
        $(el).find('.js-tests-accordion-content').slideUp()
      }
    })
  }

})